// @ts-ignore
import {points, centerMean} from '@turf/turf';

const getCenter = (places: Partial<Place>[]) => {
  if (!places.length) return [0, 0] as [number, number];

  const locations = points(
    places.filter((place) => place.location?.coordinates).map((place) => place.location?.coordinates || [0, 0])
  );

  const centerCoordinates = centerMean(locations)?.geometry?.coordinates;

  return [centerCoordinates?.[0] || 0, centerCoordinates?.[1] || 0] as [number, number];
};

export default getCenter;
